// extracted by mini-css-extract-plugin
export var cardLayout = "_6t-1";
export var paginationContainer = "_6t-0";